import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme.css'
import { initTheme } from '@/utils/theme'
import App from './App.vue'
import router from './router'

Vue.use(ElementUI)
Vue.config.productionTip = false

initTheme()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
